module.exports = __webpack_public_path__ + "static/img/texture-violet.6541001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/texture-violet.png
// module id = N9EL
// module chunks = 0